import { createAsyncThunk } from '@reduxjs/toolkit';
import { get } from '../models/base';

export const fetchUser = createAsyncThunk(
  'user/fetchUser',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await get(`/api/users/${userId}`);
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);
